export default __webpack_public_path__ + "static/media/Sopa-De-Spinafres.0854b01b.jpg";